import { render, staticRenderFns } from "./VTab.vue?vue&type=template&id=55a0f70c&scoped=true&"
import script from "./VTab.vue?vue&type=script&lang=ts&"
export * from "./VTab.vue?vue&type=script&lang=ts&"
import style0 from "./VTab.vue?vue&type=style&index=0&id=55a0f70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0f70c",
  null
  
)

export default component.exports